import React, { useContext, useEffect } from 'react';
import { useBiLogger } from '@wix/da-bi/pkg/hooks/useBiLogger';
import { AdProviders } from './constants';
import { SessionContext } from '@wix/da-react-context/pkg/SessionContext';
import { AdContext } from './AdContext';
/**
 * Init is used to init the clientside ads
 */ const AdInit = ()=>{
    const logBiEvent = useBiLogger();
    const { adsEnabled  } = useContext(SessionContext);
    const { DaAds  } = useContext(AdContext);
    useEffect(()=>{
        if (adsEnabled && DaAds) {
            DaAds.init([
                AdProviders.Nitro
            ], logBiEvent, window.__ADUNITS__ || []);
        }
    // We only want this to run once
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return null;
};
AdInit.displayName = 'AdInit';
export default AdInit;
